/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1SweepBalanceEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_PORTFOLIO_V1_SWEEP_BALANCE_EVENT_ENTITY_NAME = 'ixc.portfolio.v1.SweepBalanceEvent';
export const ixcPortfolioV1SweepBalanceEventEntity = new schema.Entity<IxcPortfolioV1SweepBalanceEvent>(IXC_PORTFOLIO_V1_SWEEP_BALANCE_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        config: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcPortfolioV1SweepBalanceEvent) => `${entity.metadata?.eventId}` });

